import { useEffect, useState } from "react";
import { useIndexedDB } from "react-indexed-db";

import getPostsForYou from "../api/postsForYou";

function usePostsForYou(limit: number): any[] {

    const [data, setData] = useState<any[]>([]);
    const { getAll } = useIndexedDB("visitedCategories");

    useEffect(() => {
        (async () => {
            const visitedCategories = (await getAll()).sort((a, b) => b.count - a.count);

            const topThreeCategories = visitedCategories.slice(0, 3);
            const topThreeCategoriesId = topThreeCategories.map(({ categoryId }) => +categoryId);

            const posts = await getPostsForYou(topThreeCategoriesId, limit);

            setData(posts);
        })();

    }, []);

    return data;
}

export default usePostsForYou;